import * as React from 'react';
import Styled from 'styled-components';

import { Card, ICardProps } from '../Card';
import { VALID_COLOR } from '../../lib/StyledComponents';

export interface IAlertProps {
  alertStyle?: VALID_COLOR;
}

const DEFAULT_ALERT: VALID_COLOR = 'default';

export const Alert = Styled(({ alertStyle, ...rest }) => <Card {...rest} />)<ICardProps & IAlertProps>`
  background-color: ${({ theme: { alert }, alertStyle }) => alert[alertStyle || DEFAULT_ALERT].colorBackground};
  color: ${({ theme: { alert }, alertStyle }) => alert[alertStyle || DEFAULT_ALERT].colorText};
  border: ${({ theme: { alert }, alertStyle }) => `${alert.borderWidth} solid ${alert[alertStyle || DEFAULT_ALERT].colorBorder}`};
`;

Alert.displayName = 'Alert';
